// Graph types for the flow editor. Mirrors the API's FlowNode union
// (re-exported from api.ts for convenience).

import type { FlowNode } from "../api.ts";
export type { FlowNode };

export type FlowNodeKind = FlowNode["kind"];

/** The graph as we work with it locally. The `positions` field is
 *  persisted alongside the graph so layouts survive across sessions
 *  (it's a no-op for the renderer — extra jsonb fields are ignored
 *  by render-flow.ts). */
export interface Graph {
  rootId: string;
  nodes: Record<string, FlowNode>;
  positions: Record<string, { x: number; y: number }>;
  /** Stable display number per node ("#3" badges). Persisted like
   *  `positions` (ignored by render-flow.ts). Entries for deleted
   *  nodes are kept on purpose: numbers are never reused, so "#4"
   *  always means the same block for the whole life of a flow. */
  seqs: Record<string, number>;
}

/** Block visual size in graph (pixel) coordinates. */
export const BLOCK_W = 220;
export const BLOCK_H = 96;
